import { render, staticRenderFns } from "./PostListTable.vue?vue&type=template&id=469e83de&scoped=true"
import script from "./PostListTable.vue?vue&type=script&lang=js"
export * from "./PostListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469e83de",
  null
  
)

export default component.exports